import { WorkOrder, WorkOrderCase, Vehicle } from '@quorum/models/xs-resource';
import { WorkOrderCaseQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum WorkOrderCasesEntityActionTypes {
  GetWorkOrderCasesFromServer = '[Fixed Operations] Get Work Order Cases From Server',
  GetWorkOrderCasesFromServerError = '[Fixed Operations] Get Work Order Cases From Server Error',
  GetWorkOrderCasesFromServerSuccess = '[Fixed Operations] Get Work Order Cases From Server Success',
  UpdateWorkOrderCaseOnServer = '[Fixed Operations] Update Work Order Case From Server',
  UpdateWorkOrderCaseOnServerError = '[Fixed Operations] Update Work Order Case From Server Error',
  UpdateWorkOrderCaseOnServerSuccess = '[Fixed Operations] Update Work Order Case From Server Success',
  DeleteWorkOrderCaseFromServer = '[Fixed Operations] Delete Work Order Case From Server',
  DeleteWorkOrderCaseFromServerError = '[Fixed Operations] Delete Work Order Case From Server Error',
  DeleteWorkOrderCaseFromServerSuccess = '[Fixed Operations] Delete Work Order Case From Server Success',
  CreateWorkOrderCaseOnServer = '[Fixed Operations] Create Work Order Case On Server',
  CreateWorkOrderCaseOnServerError = '[Fixed Operations] Create Work Order Case On Server Error',
  CreateWorkOrderCaseOnServerSuccess = '[Fixed Operations] Create Work Order Case On Server Success',
}

//#region message-types
export class GetWorkOrderCasesFromServer implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.GetWorkOrderCasesFromServer;
  constructor(public payload: { params: WorkOrderCaseQueryParameters; returnAction: any }) {}
}
export class GetWorkOrderCasesFromServerError implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.GetWorkOrderCasesFromServerError;
  constructor(public payload: any) {}
}
export class GetWorkOrderCasesFromServerSuccess implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.GetWorkOrderCasesFromServerSuccess;
  constructor(public payload: WorkOrderCase[]) {}
}

export class UpdateWorkOrderCaseOnServer implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.UpdateWorkOrderCaseOnServer;
  constructor(public payload: WorkOrderCase) {}
}
export class UpdateWorkOrderCaseOnServerError implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.UpdateWorkOrderCaseOnServerError;
  constructor(public payload: any) {}
}
export class UpdateWorkOrderCaseOnServerSuccess implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.UpdateWorkOrderCaseOnServerSuccess;
  constructor(public payload: WorkOrderCase) {}
}

export class DeleteWorkOrderCaseFromServer implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.DeleteWorkOrderCaseFromServer;
  constructor(public payload: WorkOrderCase) {}
}
export class DeleteWorkOrderCaseFromServerError implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.DeleteWorkOrderCaseFromServerError;
  constructor(public payload: any) {}
}
export class DeleteWorkOrderCaseFromServerSuccess implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.DeleteWorkOrderCaseFromServerSuccess;
  constructor(public payload: WorkOrderCase) {}
}

export class CreateWorkOrderCaseOnServer implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.CreateWorkOrderCaseOnServer;
  constructor(
    public payload: { workOrderCase: WorkOrderCase; servicePricing: any; vehicle: Vehicle; workOrder: WorkOrder }
  ) {}
}
export class CreateWorkOrderCaseOnServerError implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.CreateWorkOrderCaseOnServerError;
  constructor(public payload: any) {}
}
export class CreateWorkOrderCaseOnServerSuccess implements Action {
  readonly type = WorkOrderCasesEntityActionTypes.CreateWorkOrderCaseOnServerSuccess;
  constructor(public payload: { workOrderCase: WorkOrderCase }) {}
}
//#endregion

export type WorkOrderCasesEntityAction =
  | GetWorkOrderCasesFromServer
  | GetWorkOrderCasesFromServerError
  | GetWorkOrderCasesFromServerSuccess
  | UpdateWorkOrderCaseOnServer
  | UpdateWorkOrderCaseOnServerError
  | UpdateWorkOrderCaseOnServerSuccess
  | DeleteWorkOrderCaseFromServer
  | DeleteWorkOrderCaseFromServerError
  | DeleteWorkOrderCaseFromServerSuccess
  | CreateWorkOrderCaseOnServer
  | CreateWorkOrderCaseOnServerError
  | CreateWorkOrderCaseOnServerSuccess;

export const fromWorkOrderCasesEntityActions = {
  GetWorkOrderCasesFromServer,
  GetWorkOrderCasesFromServerError,
  GetWorkOrderCasesFromServerSuccess,
  UpdateWorkOrderCaseOnServer,
  UpdateWorkOrderCaseOnServerError,
  UpdateWorkOrderCaseOnServerSuccess,
  DeleteWorkOrderCaseFromServer,
  DeleteWorkOrderCaseFromServerError,
  DeleteWorkOrderCaseFromServerSuccess,
  CreateWorkOrderCaseOnServer,
  CreateWorkOrderCaseOnServerError,
  CreateWorkOrderCaseOnServerSuccess,
};
